/** Console — water meter list (watermeter.vue) */
export default {
  deviceWater: {
    searchPlaceholder: 'Meter name or device no.',
    waterTypePlaceholder: 'Meter type',
    onlineStatusPlaceholder: 'Online status',
    online: 'Online',
    offline: 'Offline',
    search: 'Search',
    reset: 'Reset',
    export: 'Export',
    exportCurrentPage: 'Export current page',
    exportSelected: 'Export selected',
    exportAll: 'Export all',
    sectionList: 'Meter list',
    sectionCard: 'Meter cards',
    add: 'Add',
    sortDefault: 'Default sort',
    viewList: 'List',
    viewCard: 'Cards',
    selectedCount: '{count} selected',
    bindTypeDedicated: 'Dedicated',
    bindTypePublic: 'Shared allocation',
    bindTypeFormula: 'Formula',
    bindTagDedicated: 'Dedicated',
    bindTagPublic: 'Shared',
    bindTagFormula: 'Formula',
    prepaid: 'Prepaid',
    prepaidStrong: 'Direct control',
    valveOpen: 'Valve open',
    valveClose: 'Valve closed',
    switchSupportYes: 'Yes',
    switchSupportNo: 'No',
    tagValveSupport: 'Valve control',
    tagValveNotSupport: 'No valve control',
    supportShort: 'Yes',
    notSupportShort: 'No',
    colDeviceNo: 'Device no.',
    colWaterName: 'Meter name',
    colBindInfo: 'Binding',
    colType: 'Type',
    colValveSupport: 'Valve control',
    colPayMode: 'Payment mode',
    colValveStatus: 'Valve status',
    colOnline: 'Online status',
    colUpdateTime: 'Last reading time',
    colCreateTime: 'Created',
    copyDeviceNoTip: 'Click to copy',
    opColumn: 'Actions',
    opEdit: 'Edit',
    opDetail: 'Details',
    unbound: 'Unbound',
    emptyNoData: 'No data',
    cardDeviceNo: 'Device no.',
    cardBindInfo: 'Binding',
    cardPayMode: 'Payment mode',
    cardLatest: 'Latest reading',
    popoverBindId: 'Bind ID',
    popoverBindName: 'Binding',
    dialogEditTitle: 'Edit meter',
    dialogAddTitle: 'Add meter',
    labelDeviceNo: 'Device no.',
    labelWaterName: 'Meter name',
    labelWaterType: 'Meter type',
    labelAccessChannel: 'Access channel',
    labelDeviceModel: 'Model',
    labelValveSupport: 'Valve control',
    labelManufacturerNo: 'Manufacturer no.',
    labelPayMode: 'Payment mode',
    labelBillingPlan: 'Billing plan',
    placeholderDeviceNo: 'Enter device number',
    placeholderWaterName: 'Enter meter name',
    placeholderSelectWaterType: 'Select meter type',
    placeholderSelectChannel: 'Select channel',
    placeholderDeviceModel: 'Enter model',
    placeholderSelectValve: 'Select',
    placeholderSelectPayMode: 'Select payment mode',
    placeholderSelectBilling: 'Select billing plan',
    placeholderManufacturer: 'Select manufacturer no.',
    priceOptionLabel: '{name} (¥{price}/ton)',
    btnCancel: 'Cancel',
    btnConfirm: 'OK',
    saving: 'Saving…',
    ruleWaterName: 'Meter name is required',
    ruleSerial: 'Device number is required',
    ruleModel: 'Model is required',
    ruleBindType: 'Select a meter type',
    errFetchList: 'Failed to load data',
    errFetchWater: 'Failed to load water meters',
    errPriceList: 'Failed to load water tariff plans',
    successSaveUpdate: 'Saved',
    successSaveAdd: 'Created',
    errOperation: 'Operation failed',
    warnNothingToCopy: 'Nothing to copy',
    successSerialCopied: 'Device number copied',
    errCopy: 'Copy failed',
    warnNotBound: 'This meter is not bound to a tenant',
    warnTenantIdMissing: 'Tenant ID missing',
    warnNoExportData: 'No data to export',
    warnNoSelectedExport: 'Please select rows to export',
    successExported: 'Exported {count} row(s)',
    successExportedSelection: 'Exported {count} selected row(s)',
    successExportedLimit: '{total} row(s) in total, first {count} row(s) exported',
    errExport: 'Export failed',
    exporting: 'Exporting...',
    exportSheetName: 'Water meters',
    exportFilePrefix: 'water-meters',
    importTodo: 'Import is not available yet.',
    batchTodo: 'Batch actions are not available yet.',
    channelNs: 'Smart IoT — Nanshuo',
    channelNsNew: 'Smart IoT — Nanshuo (New)',
    channelNsThirdParty: 'Smart IoT — Nanshuo (Third-party)',
    channelCameraDirect: 'Camera direct reading',

    waterDrawerTitle: 'Water meter details',
    waterDrawerColId: 'ID',
    waterDrawerColModel: 'Model',
    waterDrawerColInstallLoc: 'Install location',
    waterDrawerLabelValveSupport: 'Valve control',
    waterDrawerNoBind: 'No binding information',
    waterDrawerNoPricePlan: 'No water tariff plan',
    waterDrawerPricePlanLabel: 'Water tariff plan',
    waterDrawerPricePerTon: '¥{price}/m³',
    waterDrawerSectionUsage: 'Recent usage',
    waterDrawerLinkFullReport: 'Open full report',
    waterDrawerColTime: 'Date',
    waterDrawerColEndRead: 'Reading (m³)',
    waterDrawerColConsumption: 'Usage (m³)',
    waterDrawerColWaterFee: 'Fee (¥)',
    waterDrawerEmptyUsage: 'No usage statistics',
    confirmTitle: 'Notice',
    confirmValveMsg: 'Run {action} on this meter?',
    successValveAction: '{action} succeeded',
    errValveAction: '{action} failed',
    warnNoValveSupport: 'This meter does not support valve control',
    errUpdate: 'Update failed',
    ruleChannel: 'Select an access channel'
  }
}
